import React, { useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import Footer from "../../components/Footer.jsx";
import { useDispatch, useSelector } from "react-redux";
import {
  goldAndSliverBuyApi,
  resetState,
} from "../../redux/features/goldAndSilver/goldAndSilverBuySlice.js";
import Loader from "../../components/Loader.jsx";
import { load } from "@cashfreepayments/cashfree-js";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axiosInstance.js";
import CustomButton from "../../components/CustomButton.jsx";
import { decryptFields } from "../../utils/kycStatus.js";
import BackButton from "../../components/BackButton.jsx";
import { KycInfo } from "../../components/KycInfo.jsx";

function BuySummary() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation();
  const { orderSummary, gst, totalAmt, priceExpire, buyBtn } = t(
    "goldOrderSummaryPage"
  );

  const [kycDone, setKycDone] = useState(false);
  const [addressId, setAddressId] = useState(null);

  const GetAddressKycAPI = async () => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/address/get_address`;
      const response = await axiosInstance.get(url);
      const addressId = response?.data?.data?.[0]?.id || null;

      if (!response.data.error) {
        const userDetails =
          JSON.parse(localStorage.getItem("userDetails")) || {};
        if (addressId) {
          setAddressId(addressId);
          userDetails.addressId = addressId;
          localStorage.setItem("userDetails", JSON.stringify(userDetails));
        }
      } else {
        toast.error(response.data.message || "Failed to fetch address");
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      toast.error("Something went wrong while fetching the address");
    }
  };

  const isGold = location.pathname.includes("gold") ? "Gold" : "Silver";
  const data = location.state;
  const provider = location.state.key === "augmont" ? true : false;
  const [razorpayResponse, setRazorpayResponse] = useState(null);

  const {
    preTaxAmount: mmtcPreTaxAmount = "0",
    quantity: mmtcQuantity = "0",
    taxAmount: mmtcTaxAmount = "0",
    totalAmount: mmtcTotalAmount = "0",
    metalRate: mmtcLiveRate = "0",
    transactionRefNo: mmtcTransactionRefNo = "0",
  } = data?.data?.data?.[0] || {};

  const {
    totalQuantity: augQuantity,
    totalAmount: augAmount,
    gst: augGst,
    amountAfterTax: augAmountAfterTax,
    merchantTransactionId: augMerchantTransactionId,
    metalType: augMetalType,
    pricePerGram: augLivePrice,
  } = data?.data?.data?.[0] || {};

  const mClick = data.clickFirst;

  useEffect(() => {
    dispatch(resetState());
  }, [dispatch]);

  useEffect(() => {
    if (!provider) GetAddressKycAPI();
  }, [provider]);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (userDetails) {
      const decryptedData = decryptFields(userDetails, [
        "pan",
        "address",
        "bank",
      ]);
      if (
        decryptedData.pan === true &&
        decryptedData.address === true &&
        decryptedData.bank === true
      ) {
        setKycDone(true);
      }
    }
  }, []);

  const buyApiLoading = useSelector(
    (state) => state.goldAndSilverBuySlice.status
  );
  const buyApiResponse = useSelector(
    (state) => state.goldAndSilverBuySlice.data
  );

  const {
    data: buyApiRes,
    errors,
    status,
  } = useSelector((state) => state.goldAndSilverBuySlice);

  const { totalAmount, transactionId } =
    Array.isArray(buyApiResponse?.data) && buyApiResponse?.data.length > 0
      ? buyApiResponse?.data[0]?.result?.data || {}
      : {};

  const [augmontLoading, setAugmontLoading] = useState(false);

  const handlePayment = async () => {
    if (augAmountAfterTax > 1000000) {
      toast.error("Can't buy more than 1000000");
      return;
    }
    try {
      setAugmontLoading(true);
      const paymentData = {
        TotalAmount: augAmountAfterTax,
        transaction_id: augMerchantTransactionId,
      };
      const response = await axiosInstance.post("/cashfree", paymentData);

      if (response.data.error === false) {
        // await handleOpenRazorpay(response.data.data);
        await openCashfree(response.data.data);
      } else {
        Swal.fire({
          title: response.data.message || "Something went wrong",
          text: "An error occurred.",
          icon: "error",
          confirmButtonColor: "#3085d6",
        });
      }
    } catch (error) {
      Swal.fire({
        title: error.response.data.message || "Something went wrong",
        text: "An error occurred.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      console.error("Error handling payment:", error);
    } finally {
      setAugmontLoading(false);
    }
  };

  // ===== CASH FREE================

  const [loading, setLoading] = useState(false);

  const openCashfree = async (apiResponse) => {
    const cashfree = await load({
      mode: process.env.REACT_APP_CASHFREE,
    });

    let checkoutOptions = {
      paymentSessionId: apiResponse.payment_session_id,
      redirectTarget: "_modal",
      style: {
        logo: "https://uat.batuk.in//assets/BatukLogo.png",
      },
    };

    cashfree.checkout(checkoutOptions).then((result) => {
      if (result.error) {
        toast.error(result.error);
      }
      if (result.redirect) {
        console.log("Payment will be redirected");
      }
      if (result.paymentDetails) {
        console.log("Payment has been completed, Check for Payment Status");

        const requestBody = {
          merchantTransactionId: augMerchantTransactionId,
          metalType: augMetalType,
        };

        if (mClick === "A") {
          requestBody["amount"] = augAmountAfterTax;
        } else if (mClick === "Q") {
          requestBody["quantity"] = augQuantity;
        } else {
          requestBody["amount"] = augAmountAfterTax;
        }
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          dispatch(goldAndSliverBuyApi(requestBody));
        }, 5000);
      }
    });
  };

  const handleOpenRazorpay = async (data) => {
    try {
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: Number(data.amount),
        currency: data.currency,
        name: "Bharat Batuk Pvt.ltd.",
        description: "XYZ",
        order_id: data.id,
        handler: async function (response) {
          setRazorpayResponse(response);

          const requestBody = {
            merchantTransactionId: augMerchantTransactionId,
            metalType: augMetalType,
          };

          if (mClick === "A") {
            requestBody["amount"] = augAmountAfterTax;
          } else if (mClick === "Q") {
            requestBody["quantity"] = augQuantity;
          } else {
            requestBody["amount"] = augAmountAfterTax;
          }

          await dispatch(goldAndSliverBuyApi(requestBody));
        },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Error handling Razorpay", error);
      throw error;
    }
  };

  // useEffect(() => {
  //   if (totalAmount) {
  //     Swal.fire({
  //       title: "Payment Successful",
  //       html: `Transaction Number: ${transactionId}<br/><br/>Amount: ₹${totalAmount}`,
  //       icon: "success",
  //     });
  //     navigate(
  //       isGold == "Gold" ? "/dashboard/invoice" : "/dashboard/silverinvoice",
  //       {
  //         state: {
  //           buyData: buyApiResponse || "",
  //           provider: "augmont",
  //         },
  //       }
  //     );
  //     dispatch(resetState());
  //   }
  // }, [totalAmount, dispatch]);

  useEffect(() => {
    if (totalAmount) {
      Swal.fire({
        title: "Payment Successful",
        html: `Transaction Number: ${transactionId}<br/><br/>Amount: ₹${totalAmount}`,
        icon: "success",
      });
      navigate("/dashboard/invoice", {
        state: {
          buyData: buyApiResponse || "",
          provider: "augmont",
        },
      });
      dispatch(resetState());
    }
  }, [totalAmount, dispatch]);

  // MMTC API's=============================

  const mmtcQuoteApi = async () => {
    try {
      const payload = {
        ...data?.data?.data?.[0],
        billingAddressId: addressId || null,
      };
      const response = await axiosInstance.post(
        "/customTrade/validateBuy",
        payload
      );

      const quoteApiResponse = response?.data?.data?.[0];

      if (!response.data.error) {
        openMmtcRazorpay(quoteApiResponse);
      } else {
        toast.error("ERROR IN MMTC validateBuy API");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const openMmtcRazorpay = async (quoteApiResponse) => {
    try {
      const options = {
        key: quoteApiResponse?.key,
        amount: Number(quoteApiResponse?.orderId?.total_amount),
        name: "Bharat Batuk Pvt.ltd.",
        description: "XYZ",
        order_id: quoteApiResponse?.id,
        method: {
          upi: false,
          netbanking: true,
          card: true,
        },
        handler: async function (response) {
          // await dispatch(goldAndSliverBuyApi(requestBody));
          mmtcExecuteBuy(response);
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Error handling Razorpay", error);
      throw error;
    }
  };

  const [executeApiLoading, setExecuteApiLoading] = useState(false);

  const mmtcExecuteBuy = async (razorpayResponse) => {
    try {
      setExecuteApiLoading(true);
      const payload = {
        ...data.data.data?.[0],
        paymentid: razorpayResponse?.razorpay_payment_id,
        pgorder_id: razorpayResponse?.razorpay_order_id,
        pgSignature: razorpayResponse?.razorpay_signature,
      };

      const response = await axiosInstance.post(
        "/customTrade/executeBuy",
        payload
      );

      if (!response.data.error) {
        Swal.fire({
          title: response.data.message || "Success",
          icon: "success",
          confirmButtonColor: "#3085d6",
        });
        // navigate("/dashboard/history");
        navigate("/dashboard/invoice", {
          state: {
            buyData: response?.data?.data?.[0] || "",
            provider: "mmtc",
            metal: isGold,
          },
        });
      } else {
        toast.error("eXecute API ERROR TRUE");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setExecuteApiLoading(false);
    }
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    if (userDetails) {
      const decryptedData = decryptFields(userDetails, [
        "pan",
        "address",
        "bank",
      ]);
      if (
        decryptedData.pan === true &&
        decryptedData.address === true &&
        decryptedData.bank === true
      ) {
        setKycDone(true);
      }
    }
  }, []);

  useEffect(() => {
    // If this flag exists → the page was refreshed
    if (sessionStorage.getItem("page-refreshed") === "true") {
      sessionStorage.removeItem("page-refreshed");
      navigate(
        isGold == "Gold" ? "/dashboard/gold/buy" : "/dashboard/silver/buy"
      );
    }

    const handleBeforeUnload = () => {
      // Set the flag before the page actually reloads
      sessionStorage.setItem("page-refreshed", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [navigate]);

  return (
    <main>
      {buyApiLoading || loading || executeApiLoading ? (
        <div style={{ height: "90vh" }}>
          <Loader />
        </div>
      ) : errors &&
        (!buyApiRes || (Array.isArray(buyApiRes) && buyApiRes.length === 0)) ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <img src="/images/loadingTransaction.png" alt="loading" width="30%" />
          <h2>Uh-oh!...</h2>
          <p>
            It's taking longer than expected. <br /> Don't worry your money is
            Safe. <br /> We will update your Gold balance soon.
          </p>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              margin: "1rem auto",
            }}
          >
            <div>We will be redirected in: </div>
            <CountdownCircleTimer
              isPlaying
              size={60}
              strokeWidth={10}
              duration={15} // now 15 seconds
              colors={["#510d10", "#510d10", "#510d10", "#510d10"]}
              colorsTime={[15, 10, 5, 0]}
              onComplete={() => {
                navigate(
                  isGold == "Gold"
                    ? "/dashboard/gold/buy"
                    : "/dashboard/silver/buy"
                );
                return { shouldRepeat: false };
              }}
            >
              {({ remainingTime }) => {
                const minutes = Math.floor(remainingTime / 60);
                const seconds = remainingTime % 60;
                const formattedTime = `${minutes}:${seconds
                  .toString()
                  .padStart(2, "0")}`;
                return (
                  <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                    {formattedTime}
                  </div>
                );
              }}
            </CountdownCircleTimer>
          </div>
        </div>
      ) : (
        <div className="summary_container">
          <BackButton />
          <div>
            <div style={{ textAlign: "center" }}>
              <h2>{orderSummary}</h2>
            </div>
            {/* DETAILS=======  */}
            <section
              style={{
                display: "flex",
                justifyContent: "space-around",
                gap: "1rem",
                // fontSize: "1.2rem",
              }}
            >
              <div>
                <div>{isGold} Weight (gm)</div>
                <div>{isGold} Rate per gram (₹)</div>
                <div>
                  {isGold} Value Of {provider ? augQuantity : mmtcQuantity}
                  /gm (&#8377;)
                </div>
                <div>{gst} (&#8377;)</div>
                <strong>{totalAmt} (&#8377;)</strong>
              </div>
              <div>
                <div>{provider ? augQuantity : mmtcQuantity}</div>
                <div>{provider ? augLivePrice : mmtcLiveRate}</div>
                <div>{provider ? augAmount : mmtcPreTaxAmount}</div>
                <div>{provider ? augGst : mmtcTaxAmount}</div>
                <strong>
                  {provider ? augAmountAfterTax : mmtcTotalAmount}
                </strong>
              </div>
            </section>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "5px",
                alignItems: "center",
                textAlign: "center",
                margin: "2rem auto",
              }}
            >
              <span className=" mt-2 mr-3">{priceExpire}</span>{" "}
              <CountdownCircleTimer
                isPlaying
                size={60}
                strokeWidth={10}
                duration={180} // 3 minutes in seconds
                colors={["#510d10", "#510d10", "#510d10", "#510d10"]}
                colorsTime={[180, 120, 60, 0]}
                onComplete={() => {
                  navigate(-1);
                  return { shouldRepeat: false };
                }}
              >
                {({ remainingTime }) => {
                  const minutes = Math.floor(remainingTime / 60);
                  const seconds = remainingTime % 60;
                  const formattedTime = `${minutes}:${seconds
                    .toString()
                    .padStart(2, "0")}`;
                  return (
                    <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {formattedTime}
                    </div>
                  );
                }}
              </CountdownCircleTimer>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "2rem auto",
              }}
            >
              {kycDone ? (
                <CustomButton
                  label="Buy"
                  loading={augmontLoading}
                  disable={augmontLoading}
                  onClick={provider ? handlePayment : mmtcQuoteApi}
                />
              ) : (
                <Link to="/dashboard/profile/profileSetting">
                  <CustomButton label=" Complete KYC" />
                </Link>
              )}
            </div>
            <Footer metalType={isGold} />
          </div>
          {/* KYC INFO=============  */}
          {!kycDone && <KycInfo />}
        </div>
      )}
    </main>
  );
}

export default BuySummary;
